#import "./ProductCardFragment.gql"

query ProductCardByVariantIdQuery($id: String!) {
  productVariant(id: $id) {
    product {
      ...ProductCardFragment
    }
  }
}
